'use client'

import Link from 'next/link'
import { Button } from '../ui/button'

  export function SiteLink({ href, scrollBefore, text, target, rel }: { href?: string, scrollBefore?: boolean, text: string, target?: string, rel?: string }) {
    return (
    <Button aria-label='SITE_BUTTON' variant='link' size='sm' className='p-0 text-xs text-muted-foreground hover:text-foreground'>
      {href && scrollBefore && <Link href={href} className='p-2 sm:px-3' target={target} onClick={() => window.scrollTo(0, 0)} rel={rel}>{text}</Link>}
      {href && !scrollBefore && <Link href={href} className='p-2 sm:px-3' target={target} rel={rel}>{text}</Link>}
    </Button>
    )
  }